import { useMemo } from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import scheduleConfig from '../../../config/schedule'
import { NEW_CALENDAR_FLAG } from '../../../config/feature/flags'

interface CalendarConfig {
  calendars: {
    mainStage: string
    sessions: string
    multiStage: string
  }
  useNewCalendar: boolean
}

/**
 * Resolves which calendars Zion's aggregate schedule hooks should read.
 *
 * Zion takes this as a prop rather than reading Split itself, so the flag lookup and the
 * BSP calendar names stay in the app. `useNewCalendar` false means main-stage + sessions;
 * true means multi-stage only. An unresolved flag reports `control`, so this is false until
 * Split answers — the pre-flag pair is the safe default.
 */
export default function useCalendarConfig(): CalendarConfig {
  const newCalendarFlag = useFeatureFlag(NEW_CALENDAR_FLAG)
  const useNewCalendar = Boolean(newCalendarFlag?.isOn)

  return useMemo(() => ({ calendars: scheduleConfig.calendarConfig.calendars, useNewCalendar }), [useNewCalendar])
}
